(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/racing/wager/assets/javascripts/wager.js') >= 0) return;  svs.modules.push('/components/racing/wager/assets/javascripts/wager.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  getPaymentDoneMessage,
  getPaymentConfirmMessage
} = svs.components.sport;
const {
  constants: {
    quickpickProps: qpProps,
    gameTypeToSubProductId,
    gameTypes,
    systemTypes,
    drawStates
  },
  strings: {
    getProductName
  }
} = svs.racing.common;
const {
  crossSellUtil
} = svs.components.racing.cross_sell;
const {
  formatDate
} = svs.components.lbUtils.helpers.formatDate;
const {
  paramHandler
} = svs.utils;
const {
  feature
} = svs.core.detect;
const {
  createStandardPaymentFlow
} = svs.components.wagerPaymentFlow.standardFlow;
const {
  createMarketplacePaymentFlow
} = svs.components.wagerPaymentFlow.marketplaceFlow;
const {
  executePayment
} = svs.components.wagerPaymentFlow.executePayment;
const {
  createWager
} = svs.components.payment;
const {
  groupTypes,
  convertRoleToTypeOfShare
} = svs.components.marketplaceData.constants;
const {
  productIds,
  getDisplayName
} = svs.utils.products;
const generateTrackingId = () => Math.floor((Math.random() + 1) * Date.now()).toString(36);
const payConvertedWager = async (highFourWager, quickpick, race, marketplace, marketplaceAccount) => {
  const composedWager = highFourWager.compose();
  const payMessage = getPaymentConfirmMessage({
    amount: composedWager.bets[0].betAmountSalesGroup1,
    productName: getDisplayName(productIds.RACING),
    marketplaceGroup: undefined
  });
  const extradata = {
    system: 'topRank',
    typeOfGame: 'High 4',
    quickpick
  };
  const highFourWagerProps = {
    productId: 'RX',
    message: payMessage,
    betAmount: parseInt(composedWager.bets[0].betAmountSalesGroup1, 10),
    gameType: 'rx4io',
    systemType: systemTypes.TOP_RANK,
    extradata
  };
  const paymentBuilder = createStandardPaymentFlow({
    config: {
      haltPaymentOnException: true
    },
    wagers: [highFourWager]
  }).onFinally((result, error) => {
    if (!error) {
      onPaySuccess({
        response: result,
        wager: highFourWager,
        wagerProps: highFourWagerProps,
        race,
        marketplace,
        marketplaceAccount
      });
    }
  });
  await executePayment(paymentBuilder, {
    userContext: {
      uniqueTrackingId: generateTrackingId()
    }
  });
};
const onPaySuccess = _ref => {
  let {
    response,
    wager,
    wagerProps,
    draws,
    participants,
    toRaceWithRow,
    isRetailerAdmin,
    race,
    marketplace,
    marketplaceAccount,
    isMarketplace
  } = _ref;
  const betAmount = response === null || response === void 0 ? void 0 : response.getPaidAmount();
  let transferTo;
  if (!isMarketplace && wagerProps.gameType === gameTypes.TOPP5 && (wagerProps.systemType === systemTypes.TOP_RANK || wagerProps.systemType === systemTypes.TOP_RANK_PIX)) {
    const highFourDraw = draws.filter(draw => draw.gameType === 'rx4io')[0];
    if (highFourDraw && highFourDraw.drawState === drawStates.OPENED) {
      transferTo = {
        customTitle: 'Vill du överföra ditt spel till High 4?',
        gameName: 'High 4',
        abortAction: () => {
          svs.components.dialog.api.close();
        },
        transferAction: () => {
          svs.components.dialog.api.close();
          crossSellUtil.convertHighFiveToHighFourWager(race, wager, wagerProps, highFourDraw, participants, toRaceWithRow, highFourWager => {
            payConvertedWager(highFourWager, wagerProps.extradata.quickpick, race, marketplace, marketplaceAccount);
          });
        }
      };
    }
  }
  const marketplaceUrl = marketplaceAccount && "".concat(svs.core.urlMapping.get('marketplace')).concat(marketplace.helpers.getTeamUrl(marketplaceAccount.groupId, marketplaceAccount.name, 'spel', marketplaceAccount.containerId, marketplaceAccount.activatedDrawId));

  getPaymentDoneMessage({
    amount: betAmount,
    okAction: () => {
      if (svs.components.dialog.api.isBlocking) {
        svs.components.dialog.api.close();
      }
    },
    productName: getDisplayName(productIds.RACING),
    marketplaceUrl,
    isRetailer: isRetailerAdmin,
    transferTo
  }, messageObject => {
    setTimeout(() => {
      if (messageObject.transferDialogConfig) {
        svs.components.dialog.api.add(new svs.components.dialog.Confirm(_objectSpread(_objectSpread({}, messageObject.transferDialogConfig), {}, {
          message: [{
            type: svs.components.dialog.message.TEXT,
            text: 'High 4 går ut på att tippa de 4 första hästarna i korrekt ordning.'
          }]
        })));
      }
    }, 500);
  });
  if (marketplaceAccount) {
    paramHandler.remove({
      key: 'activatedDrawId'
    });
    paramHandler.remove({
      key: 'fromPlayTogether'
    });
    marketplace.accountSelector.helpers.observer.notify({
      accounts: marketplace.accountSelector.helpers.observer.getValue().accounts.filter(account => account.activatedDrawId !== marketplaceAccount.activatedDrawId)
    });
  }
};

const shouldTrackRowAmount = subProductId => {
  const productsToTrackRowPrice = [gameTypeToSubProductId[gameTypes.TOPP2], gameTypeToSubProductId[gameTypes.TOPP5]];
  return productsToTrackRowPrice.indexOf(subProductId) !== -1;
};
const createWagerRx = async (engine, totalBetAmount, selectedRowPrice, drawNum, race, successCallback, toRaceWithRow, marketplaceProps) => {
  const {
    participants,
    draws
  } = race;
  const {
    marketplace,
    isRetailerAdmin
  } = marketplaceProps ? marketplaceProps : {};
  const rowPrice = engine.stake.rowPrice;
  const subProductId = engine.subProductId;
  const {
    getWagerData,
    getQP,
    getNumRows
  } = engine.selectors;
  const {
    clearAll
  } = engine.actions;
  const wagerData = getWagerData(participants);
  const rowPriceMulti = selectedRowPrice / rowPrice;
  const marketplaceAccount = marketplaceProps ? marketplace.accountSelector.helpers.getCurrentAccount() : null;
  const isMarketplace = Boolean(marketplace && marketplace.accountSelector && marketplaceAccount);
  const extradata = _objectSpread({
    typeOfGame: getProductName(engine.gameType),
    system: engine.systemType
  }, shouldTrackRowAmount(subProductId) && {
    rowAmount: rowPriceMulti
  });
  let paymentBuilder;
  if (getQP) {
    const quickPick = getQP();
    if (quickPick !== qpProps.NOQP) {
      extradata.quickpick = quickPick;
    }
  }
  const wagerProps = {
    productId: 'RX',
    betAmount: totalBetAmount,
    gameType: engine.gameType,
    systemType: engine.systemType,
    extradata
  };
  const wager = createWager.createWager().addBet(productIds.RACING, bet => bet.setSubProductId(subProductId).setDrawNumber(drawNum).setRowPrice(rowPrice).setRowPriceMulti(rowPriceMulti).setSystemType(engine.systemType).addBoard(board => board.addOutcomes(wagerData).setRowCount(getNumRows())));
  if (svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') && svs.core.config.data.svsconfig.isSelfService) {
    const productFlag = wagerProps.productId;
    const cost = wagerProps.betAmount;
    const description = "Spelstopp: ".concat(formatDate(race.startTime, true, true));
    const productProperty = {
      wagers: wager.compose(),
      isLive: false,
      headers: {
        source: 'SvS:LB:ITS'
      },
      productFlag,
      productBrand: svs.utils.products.getProductClassName(productIds.RACING),
      productTitle: getProductName(engine.gameType),
      cost,
      description
    };
    const wagerWrapper = svs.components.selfserviceCart.generateProductItem(productProperty);
    svs.components.selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
      if (!err) {
        clearAll();
        successCallback();
      }
    });
  } else if (isMarketplace) {
    const role = isRetailerAdmin ? groupTypes.RETAILER : groupTypes.PRIVATE;
    if (isRetailerAdmin) {
      wager.setCommissionPercent(marketplaceAccount.selectedCommissionPercent);
    }
    extradata.shares = true;
    extradata.typeOfShares = isRetailerAdmin ? convertRoleToTypeOfShare[groupTypes.RETAILER] : convertRoleToTypeOfShare[groupTypes.PRIVATE];
    wager.setActivatedDrawId(parseInt(marketplaceAccount.activatedDrawId, 10));
    wager.setRole(role);
    wagerProps.marketplaceAccount = marketplaceAccount;
    const isC2C = Boolean(role === groupTypes.PRIVATE);
    paymentBuilder = createMarketplacePaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wager],
      isC2C
    });
  } else {
    paymentBuilder = createStandardPaymentFlow({
      config: {
        haltPaymentOnException: true
      },
      wagers: [wager]
    });
  }
  if (paymentBuilder) {
    paymentBuilder.onFinally((result, error) => {
      if (!error) {
        onPaySuccess({
          response: result,
          wager,
          wagerProps,
          draws,
          participants,
          toRaceWithRow,
          isRetailerAdmin,
          race,
          marketplace,
          marketplaceAccount,
          isMarketplace
        });
        clearAll();
        successCallback();
      }
    });
    await executePayment(paymentBuilder, {
      userContext: {
        uniqueTrackingId: generateTrackingId()
      }
    });
  }
};
svs.components.racing.wager = {
  createWager: feature('ft-racing-new-wager') ? createWagerRx : svs.components.racing.wager.createOldWager
};

 })(window);